export const RESET = 'EXSBINVOICEPOSITION_LIST_RESET'
export const SET_ITEMS = 'EXSBINVOICEPOSITION_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBINVOICEPOSITION_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBINVOICEPOSITION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBINVOICEPOSITION_LIST_TOGGLE_LOADING'
